// Header row for the Tasks <Table>. Lives inside <thead>, so the headers
// always line up with the <td>s rendered by TaskLine.
//
// TASK_LIST_COLUMNS is declared HERE, beside the <th>s, because it is the same
// number: TaskLine's photo continuation row spans the whole width, and a span
// written anywhere else would be free to drift from the header the day a column
// is added. The logbook table computes it from `columns.length` for the same
// reason; this header is fixed, so the number is stated once instead.

export const TASK_LIST_COLUMNS = 5;

export const TaskListHeader = () => (
  <thead className="bg-body-tertiary">
    <tr>
      <th scope="col" style={{ width: 110 }}>Status</th>
      <th scope="col">
        <div>Name</div>
        <div className="text-body-secondary fw-normal small">Description / Notes</div>
      </th>
      <th scope="col" style={{ width: 200 }}>
        <div>Due (counter)</div>
        <div className="text-body-secondary fw-normal small">Counter · Interval</div>
      </th>
      <th scope="col" style={{ width: 180 }}>
        <div>Due (date)</div>
        <div className="text-body-secondary fw-normal small">Interval</div>
      </th>
      <th scope="col" style={{ width: 200 }}>
        <div>Assigned</div>
        <div className="text-body-secondary fw-normal small">Priority</div>
      </th>
    </tr>
  </thead>
);
